'use client';

import { c as _c } from "react/compiler-runtime";
import { useSession } from '@/lib/auth-client';
import { MessageBox } from './message-box';
import { Messages } from './messages';
import { Pinned } from './pinned';
import { SignIn } from './sign-in';
export function MessageBoard() {
  const $ = _c(6);
  const {
    data: session
  } = useSession();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Pinned />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== session) {
    t1 = session ? <MessageBox user={session.user} /> : <SignIn />;
    $[1] = session;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Messages />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="mx-auto max-w-xl space-y-10">{t0}{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}